// LocationController.js
import axios from 'axios';
import { Client } from '@stomp/stompjs';

const BASE_URL = 'https://mototaksi.az:9898/api';
let stompClient = null;

// Axios instance
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// ---------------------
// 🔵 HTTP Müraciətlər
// ---------------------

// İstifadəçidən (kuryerdən) son koordinatları al (backup metod)
export const getUserById = async (userId) => {
  try {
    const response = await api.get(`/v5/user/${userId}`);
    return response.data;
  } catch (error) {
    console.error("❌ Kullanıcı lokasiyası alınamadı:", error);
    return null;
  }
};

export const getUserByLocationUrl = async (trackingId) => {
  const fullUrl = `https://mototaksi.az/location/${trackingId}`;

  const response = await axios.get('https://mototaksi.az:9898/api/v5/user/by-location-url', {
    params: { url: fullUrl }
  });

  return response.data;
};

// ---------------------
// 🟢 WebSocket Bağlantısı
// ---------------------

export const connectToLocationSocket = (userId, onLocationReceived, onConnected) => {
  stompClient = new Client({
    brokerURL: 'wss://mototaksi.az:9898/ws',
    connectHeaders: {},
    reconnectDelay: 5000,

    onConnect: () => {
      console.log('📡 Lokasiya WebSocket bağlantısı quruldu.');

      stompClient.subscribe('/topic/location', (message) => {
        try {
          const body = JSON.parse(message.body);

          if (body.latitude && body.longitude && body.userId === userId) {
            onLocationReceived(body);
          }
        } catch (e) {
          console.error("❌ Lokasiya mesajı düzgün formatda deyil:", e);
        }
      });

      if (onConnected) onConnected();
    },

    onStompError: (frame) => {
      console.error("❌ STOMP Lokasiya xətası:", frame);
    }
  });

  stompClient.activate();
};

export const disconnectLocationSocket = () => {
  if (stompClient) {
    stompClient.deactivate();
    console.log("📴 Lokasiya WebSocket bağlantısı kəsildi.");
  }
};

